module.exports = "<div class=\"loader\">\n    <div class=\"loader__spinner\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/generics/loader/loader.component.html
// module id = ./src/app/generics/loader/loader.component.html
// module chunks = main